enum ErrorMessage {
  JJ001UnregisteredUserError = 'unregistered_user',
  JJ002LPUnregisteredUserError = 'unregistered_user_mq',
  JJ003UnverifiedEmailError = 'mail_verified',
  JJ004InvalidEmailOrPasswordError = 'access_denied',
  JJ012TooManyAttemptsError = 'too_many_attempts',
  not_allowed = 'not_allowed',
}

export default ErrorMessage
